import React, { useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Select, Tooltip } from "antd";
import CustomEmpty from "../../../../CustomEmpty";
import useRequest from "utils/useRequest";
import {
    getCloudDeskInfo,
    getProjectList,
    CloudDeskInfo
} from "service/experiment";
import { errorMessage } from "../../../../../../service/service";

interface ProjectListProps {
    projectId?: string;
    onChange: (value: string) => void;
    courseNo: string;
    courseSeq: string;
    onShow: () => void;
    setProjectName: (val: string) => void;
    setCloudDeskInfo: (val: CloudDeskInfo) => void;
    setCloudGuid: (val: string) => void;
    setDataLength: (val: number) => void;
}

export default function ProjectSelect({
    projectId,
    onChange,
    courseNo,
    courseSeq,
    onShow,
    setProjectName,
    setCloudDeskInfo,
    setCloudGuid,
    setDataLength
}: ProjectListProps) {
    const { Option }: any = Select;
    const [data, { loading }, refreshData] = useRequest(
        () => getProjectList(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    ); //列表项

    const [cloudInfo, setCloudInfo] = useState<CloudDeskInfo>(); // 点击列表中某一项后，该项具体数据
    const [showError, setShowError] = useState(false); //是否显示网络异常，默认不显示
    const [errorInfo, setErrorInfo] = useState(""); //网络异常提示文字

    //从data中获得cloudGuid参数，用作接口getCloudDeskInfo的参数
    const cloudGuid = useMemo(() => {
        const guid =
            data
                ?.filter(item => item.id === projectId)
                .map(item => item.cloudGuid) || [];
        return String(guid);
    }, [data, projectId]);

    useEffect(() => {
        setCloudGuid(cloudGuid);
        getCloudInfo();
    }, [cloudGuid]);

    useEffect(() => {
        const projectName = data
            ?.filter(item => String(item.id) == projectId)
            .map(item => item.projectName)[0];
        if (projectName) {
            setProjectName(projectName);
        }
    }, [data, projectId]);

    useEffect(() => {
        if (data?.length === 1) {
            onChange(data[0].id);
        }
        if (data) {
            setDataLength(data.length);
        }
    }, [data]);

    //当前接口若不能正常响应，则显示网络异常提示
    async function getCloudInfo() {
        try {
            if (cloudGuid) {
                const res = await getCloudDeskInfo(cloudGuid);
                setCloudDeskInfo(res.data.data);
                setCloudInfo(res.data.data);
                setShowError(false);
            }
        } catch (e) {
            setShowError(true);
            setErrorInfo(errorMessage(e));
        }
    }

    const handleClick = (value: string) => {
        onChange(value);
        refreshData();
    };

    return (
        <div className={style.root}>
            <Select
                value={projectId}
                style={{ width: "100%" }}
                placeholder="请选择实验项目"
                onChange={handleClick}>
                {data?.map(item => (
                    <Option
                        value={item.id}
                        key={item.id}
                        title={item.projectName}>
                        {item.projectName}
                    </Option>
                ))}
            </Select>

            {projectId && cloudGuid && (
                <div className={style.resource} onClick={onShow}>
                    查看资源
                </div>
            )}

            {!loading && projectId && !showError && cloudInfo && (
                <div className={style.info}>
                    <div className={style.item}>
                        云桌面名称：
                        <Tooltip
                            placement="topLeft"
                            title={cloudInfo.Name_label}>
                            <span>{cloudInfo.Name_label}</span>
                        </Tooltip>
                    </div>
                    <div className={style.item}>
                        操作系统：
                        <Tooltip title={cloudInfo.OsName}>
                            <span>{cloudInfo.OsName}</span>
                        </Tooltip>
                    </div>
                    <div className={style.item}>
                        安装软件：
                        <Tooltip placement="topLeft" title={cloudInfo.SoftWare}>
                            <span>{cloudInfo.SoftWare}</span>
                        </Tooltip>
                    </div>
                </div>
            )}

            {showError && projectId && (
                <div className={style.error}>
                    <CustomEmpty
                        style={{ padding: "10px 0" }}
                        description={`${errorInfo}`}
                        className={style.error}
                    />
                </div>
            )}
        </div>
    );
}
